import { render, staticRenderFns } from "./PerUser.vue?vue&type=template&id=5a58eb28&"
import script from "./PerUser.vue?vue&type=script&lang=js&"
export * from "./PerUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports